import React from 'react';
import { connect } from "react-redux";
import { updateData, updateFilterData, updateEditData } from "../actions";

class IframeUi extends React.PureComponent {
    componentDidUpdate(prevProps, prevState) {
        // const {control, formid} = this.props;
        // var nextData = this.props.data[formid] ? this.props.data[formid] : {};
        // var prevData = prevProps.data[formid] ? prevProps.data[formid] : {};
        // var nextSrc = nextData[control.src] ? nextData[control.src] : control.src;
        // var prevSrc = data[control.src] ? data[control.src] : control.src;
    }

    render() {
        const { control, formid } = this.props;
        debugger;
        var data = this.props.data[formid] ? this.props.data[formid] : {};
        var src = data[control.src] ? data[control.src] : control.src;
        if (src && src.indexOf('http') > -1) {
            return (
                <iframe className="iframeUi" runat="server" style={{ 'height': control.height }} src={src} scrolling="auto" frameBorder="0"></iframe>
            );
        } else {
            return (
                null
            )
        }
    }
}
function bindAction(dispatch) {
    return {
        update: (key, value) => dispatch(updateData(key, value)),
        updateEdit: (key, value) => dispatch(updateEditData(key, value)),
        updateFilter: (key, value) => dispatch(updateFilterData(key, value))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading,
    token: state.formLoginReducer.token,
});
export default connect(mapStateToProps, bindAction)(IframeUi);